import { OfferType } from 'src/common/apollo/types/swarmx/graphql'
import { safeDiv, ZERO } from 'src/common/utils/big-utils'
import { OfferWithTake } from 'src/common/utils/offers/findBestOffers'
import { calcOfferPrice } from 'src/common/utils/offers/offerPrices'

export const formatBuyTokenAmountSingle = (offer: OfferWithTake): Big => {
  const sellPrice = calcOfferPrice(offer, 1)
  if (
    offer.offerType === OfferType.BlockOffer ||
    offer.depositAsset.type !== 'ERC20'
  ) {
    return offer.amountIn
  } else {
    return offer.toTake.mul(sellPrice).round(offer.depositAsset.decimals, 1)
  }
}

export const formatBuyTokenAmountMulti = (offers: OfferWithTake[]): Big => {
  return offers.reduce((acc, offer) => {
    if (
      offer.offerType === OfferType.BlockOffer ||
      offer.depositAsset.type !== 'ERC20'
    ) {
      return acc.plus(offer.amountIn || ZERO)
    } else {
      return acc.plus(
        offer.toTake
          .mul(safeDiv(offer.amountIn, offer.amountOut))
          .round(offer.depositAsset.decimals, 1)
      )
    }
  }, ZERO)
}

export const formatSellTokenAmountMulti = (offers: OfferWithTake[]): Big => {
  return offers.reduce((acc, offer) => acc.plus(offer.toTake), ZERO)
}
